<template>
  <div class="google-map-viewer-layout">
    <div class="header" v-if="modalGoogleMapComponent != 'print'">
      <div
        class="title-box"
        @click="goTo('recommend')"
        :class="{ active: modalGoogleMapComponent == 'recommend' }"
      >
        <span class="title">RECOMMENDED PLACE</span>
      </div>
      <!--<div class="title-box" @click="goTo('search')"-->
      <!--:class="{'active': modalGoogleMapComponent == 'search'}">-->
      <!--<span class="title">BY SEARCH</span>-->
      <!--</div>-->
    </div>
    <div class="container">
      <div class="component-box">
        <transition name="list" appear mode="out-in">
          <keep-alive>
            <component
              v-bind:is="modalGoogleMapComponent"
              v-on:close="modalClose"
              class="component"
            ></component>
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import GoogleMapRecommend from '../common/GoogleMapRecommend'
import GoogleMapSearch from '../common/GoogleMapSearch'
import GoogleMapPrint from '../common/GoogleMapPrint'

export default {
  name: 'google-map-viewer-layout',
  props: {
    data: {
      default: () => ({}),
      type: [Object, Array]
    }
  },
  data() {
    return {
      serviceDetail: {}
    }
  },
  components: {
    recommend: GoogleMapRecommend,
    search: GoogleMapSearch,
    print: GoogleMapPrint
  },
  created() {
    // console.log('Request Page Main Layout === > ')
    this.$store.dispatch(types.SET_MODAL_REQUEST_COMPONENT, {
      component: 'mapSelect'
    })
    this.$store.dispatch(types.CLEAR_REQUEST_USER_BOOKING, {})
  },
  destroyed() {
    console.log('end')
    this.$store.dispatch(types.SET_MODAL_GOOGLE_MAP_COMPONENT, {
      component: '',
      propData: ''
    })
  },
  methods: {
    modalClose() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: '',
        active: false,
        type: 'full'
      })
    },
    goTo(menuName) {
      this.$store.dispatch(types.SET_MODAL_GOOGLE_MAP_COMPONENT, {
        component: menuName,
        propData: ''
      })
    }
  },
  computed: {
    ...mapGetters([
      'modalGoogleMapComponent',
      'modalGoogleMapComponentPropData'
    ])
  }
}
</script>

<style lang="scss" scoped>
.google-map-viewer-layout {
  /*border: 1px solid red;*/
  margin: 37px auto auto auto;
  width: 710px;
  height: auto;
  .header {
    display: flex;
    .title-box {
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      border: solid 1px #e7e7e7;
      text-align: center;
      cursor: pointer;
      &:nth-child(2) {
        border-left: 0;
      }
      .title {
        line-height: 60px;
        font-size: 16px;
        letter-spacing: 1px;
        text-align: center;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        color: #000000;
      }

      &.active {
        span {
          font-weight: 600;
          color: #ab08b6;
        }
        border-bottom: 0;
      }
    }
  }
  .container {
    width: 710px;
    height: 614px;
    overflow: hidden;
    .component-box {
      overflow-y: auto;
      position: relative;
      /*border: 1px solid red;*/
      width: inherit;
      height: inherit;
      margin: 36px 20px 60px 0;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
